import { render, staticRenderFns } from "./ChatroomSidebox.vue?vue&type=template&id=3a4c9b16&scoped=true&"
import script from "./ChatroomSidebox.vue?vue&type=script&lang=js&"
export * from "./ChatroomSidebox.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomSidebox.vue?vue&type=style&index=0&id=3a4c9b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c9b16",
  null
  
)

export default component.exports